import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { t } from "i18next";
import { toasts } from "@/shared/utils/toasts";

import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { SelectAvatar } from "@/shared/components/organisms/SelectAvatar";
import { MultiSelect } from "@/shared/components/organisms/MultiSelect";
import { ButtonWhite } from "@/shared/components/atoms/ButtonWhite";
import { Badges } from "@/shared/components/molecules/Badges";
import { Select } from "@/shared/components/organisms/Select";
import ButtonAdd from "@/shared/components/atoms/ButtonAdd";

// API
import {
  useLeadTasksQuery,
  useStoreTaskMutation,
  useAllTasksQuery,
  useCompleteTaskMutation,
  useUpdateTaskMutation,
} from "@/app/users/loyalty.api";
import { useSupportStaffQuery } from "@/app/users/users.api";
import { useTagsQuery } from "@/pages/TasksPage/api/taskApi";

type Option = { id: string | null | number; name: string };

const TaskTabs = ({ data, loading, id, branchId }: any) => {
  // State for task selection and dialog
  const [selectTask, setSelectTask] = useState<Option>({
    id: 0,
    name: t("lead.views.list_task_progress"),
  });

  const [openDialogTask, setOpenDialogTask] = useState(false);
  const [titleDialogTask, setTitleDialogTask] = useState("");
  const [textButtonSubmitTask, setTextButtonSubmitTask] = useState("");
  const [formTask, setFormTask] = useState(0);

  const useLazyLeadTasks = useLeadTasksQuery({
    id,
  });

  const [leadTasks, setLeadTasks] = useState([]);

  useEffect(() => {
    if (useLazyLeadTasks.isSuccess) {
      setLeadTasks(useLazyLeadTasks.data);
    }
  }, [useLazyLeadTasks]);

  const [listStaff, setListStaff] = useState([]);

  // State for task form
  const [taskForm, setTaskForm] = useState({
    name_task: "",
    date_task: "",
    support: "",
    labels_id: [] as (string | number)[],
  });
  const [errors, setErrors] = useState({
    name_task: "",
    date_task: "",
    support: "",
  });

  // Task options for the select dropdown
  const optionsTask: Option[] = [
    { id: 0, name: t("lead.views.list_task_progress") },
    { id: 1, name: t("lead.views.list_tasks_complete") },
    { id: 2, name: t("lead.views.list_tasks_past") },
  ];

  // API Queries and Mutations
  const usersSupportStaff = useSupportStaffQuery({ id: 25256 });

  const useLazyAllTasks = useAllTasksQuery({
    id,
    state: selectTask ? selectTask.id : 0,
  });

  const [storeTask, storeTaskResult] = useStoreTaskMutation();
  const [updateTask, updateTaskResult] = useUpdateTaskMutation();
  const [completeTask, completeTaskResult] = useCompleteTaskMutation();

  const {
    data: tags,
    isLoading,
    refetch,
  } = useTagsQuery({ branch_id: branchId });

  // Handle support staff data
  useEffect(() => {
    if (usersSupportStaff.isSuccess) {
      setListStaff(usersSupportStaff.data);
    }
  }, [usersSupportStaff]);

  // Handle lead tasks data
  useEffect(() => {
    if (useLazyLeadTasks.isSuccess) {
      setLeadTasks(useLazyLeadTasks.data);
    }
  }, [useLazyLeadTasks]);

  // Handle task creation/update result
  useEffect(() => {
    if (storeTaskResult.isSuccess) {
      toasts.success("Registro exitoso", "Tarea registrada exitosamente");
      setTaskForm({ name_task: "", date_task: "", support: "", labels_id: [] });
      setErrors({ name_task: "", date_task: "", support: "" });
      setOpenDialogTask(false);
      setFormTask(0);
      useLazyAllTasks.refetch();
    }
    if (storeTaskResult.isError) {
      toasts.danger("Error", "No se han podido registrar la tarea");
      setTaskForm({ name_task: "", date_task: "", support: "", labels_id: [] });
      setErrors({ name_task: "", date_task: "", support: "" });
      setOpenDialogTask(false);
      setFormTask(0);
    }
  }, [storeTaskResult]);

  // Handle task completion result
  useEffect(() => {
    if (completeTaskResult.isSuccess) {
      toasts.success("Completada", "Tarea completada");
      useLazyAllTasks.refetch();
    }
    if (completeTaskResult.isError) {
      toasts.danger(
        "No completada",
        "No se han podido registrar la incidencia"
      );
    }
  }, [completeTaskResult]);

  // Toggle dialog
  const handleOpenDialogTask = () => setOpenDialogTask(!openDialogTask);

  // Handle form input changes
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setTaskForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  useEffect(() => {
    if (usersSupportStaff.isSuccess) {
      setListStaff(usersSupportStaff.data);
    }
  }, [usersSupportStaff]);

  const handleMultiSelectChange = (selectedOptions: any[]) => {
    const selectedIds = selectedOptions.map((option) => option.id);
    console.log("selectedOptions", selectedIds);
    setTaskForm((prev) => ({ ...prev, labels_id: selectedIds }));
  };

  // Handle select avatar changes
  const handleSelectAvatarChange = (value: any) => {
    setTaskForm((prev) => ({ ...prev, support: value.id }));
    setErrors((prev) => ({ ...prev, support: "" }));
  };

  const [task, settask] = useState([]);

  useEffect(() => {
    if (data) {
      settask(data?.filter((x) => x.status !== "Completado"));
    }
  }, [data]);

  const [tagsList, setTagsList] = useState([]);

  useEffect(() => {
    if (tags) {
      setTagsList(tags?.map((tag) => ({ id: tag.id, name: tag.label })));
    }
  }, [tags]);
  const [ediitedTask, setEdiitedTask] = useState<any>(false);
  const [taskSelete, setTaskSelete] = useState({
    id: null,
  });

  console.log("edit task", ediitedTask);  
  // Handle form submission
  const handleSubmit = async () => {
    if (ediitedTask) {
      console.log("ediitedTask", taskSelete);
      updateTask({
        ...taskForm,
        user_task_id: id,
        lead_id: id,
        id: taskSelete.id,
        task_id: taskSelete.id,
        labels_id: taskForm.labels_id?.map((id: string | number) => {
          const tag = tagsList.find((tag: Option) => tag.id === id);
          return tag ? { id: tag.id, name: tag.name } : null;
        }),
      });
      setEdiitedTask(false);
    } else {
      storeTask({
        ...taskForm,
        user_task_id: id,
        lead_id: id,
        task_id: taskSelete.id,
        labels_id: taskForm.labels_id?.map((id: string | number) => {
          const tag = tagsList.find((tag: Option) => tag.id === id);
          return tag ? { id: tag.id, name: tag.name } : null;
        }),
      });
    }
  };

  // Handle task edit
  const handleEditTask = (task: any) => {
    setTaskSelete(task);
    setEdiitedTask(true);
    setTaskForm({
      name_task: task.name,
      date_task: task.date,
      support: task.assigned_id,
      labels_id: task.labels_id || [],
    });
    setErrors({ name_task: "", date_task: "", support: "" });
    handleOpenDialogTask();
    setTitleDialogTask(t("lead.views.new_task"));
    setTextButtonSubmitTask(t("lead.views.create_tasks"));
    setFormTask(2);
  };

  return (
    <div>
      <div className="mt-1 w-full">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between border-b border-gray-200 pb-3 mb-5 md:mb-3 mt-4">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {t("lead.views.tasks")}
          </h1>

          <div className="flex justify-end gap-x-4 mt-4 md:mt-0">
            <div className="flex items-center gap-x-4">
              <Select
                name="task"
                selected={selectTask}
                setSelected={(task) => setSelectTask(task)}
                options={optionsTask}
                tittle={""}
                textDescribe=""
              />
            </div>
            <div className="flex items-center gap-x-4">
              <ButtonAdd
                functionButton={() => {
                  setTaskForm({
                    name_task: "",
                    date_task: "",
                    support: "",
                    labels_id: [],
                  });
                  setErrors({ name_task: "", date_task: "", support: "" });
                  handleOpenDialogTask();
                  setTitleDialogTask(t("lead.views.new_task"));
                  setTextButtonSubmitTask(t("lead.views.create_tasks"));
                  setFormTask(2);
                }}
              />
            </div>
          </div>
        </div>

        <Badges
          height="90"
          projects={task ?? []}
          isLoading={
            useLazyAllTasks.isLoading || useLazyAllTasks.isFetching || loading
          }
          onEdit={handleEditTask}
          completeTask={(id_task) => {
            completeTask({ id: id_task });
          }}
        />
      </div>

      <DialogCreate
        open={openDialogTask}
        setOpen={setOpenDialogTask}
        tittle={titleDialogTask}
        tittleButtonCreate={textButtonSubmitTask}
        tittleButtonCancel={t("general.cancel")}
        OnclickCreate={handleSubmit}
        OnclickCancel={handleOpenDialogTask}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
          className="mt-6 mx-2"
        >
          <div className="space-y-12">
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("lead.views.info_task")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <InputWithCornerHint
                    label={t("lead.views.task")}
                    span={t("general.mandatory")}
                    id="name_task"
                    name="name_task"
                    type="text"
                    placeholder={t("user.views.name")}
                    value={taskForm.name_task}
                    onChange={handleInputChange}
                    error={!!errors.name_task}
                    textError={errors.name_task}
                  />
                </div>
                <div className="col-span-full">
                  <InputWithCornerHint
                    label={t("lead.views.expiration_date")}
                    span={t("general.mandatory")}
                    id="date_task"
                    name="date_task"
                    type="date"
                    value={taskForm.date_task}
                    onChange={handleInputChange}
                    error={!!errors.date_task}
                    textError={errors.date_task}
                  />
                </div>
                <div className="col-span-full">
                  <SelectAvatar
                    tittle={t("share.views.assign")}
                    span={t("general.mandatory")}
                    selected={listStaff.find(
                      (value) => value.id == taskForm.support
                    )}
                    setSelected={handleSelectAvatarChange}
                    options={listStaff}
                    error={!!errors.support}
                    textError={errors.support}
                  />
                </div>
                <div className="col-span-full">
                  <MultiSelect
                    options={tagsList}
                    selectedOptions={taskForm.labels_id.map((id) => ({
                      id,
                      name: tagsList.find((tag) => tag.id === id)?.name,
                    }))}
                    setSelectedOptions={handleMultiSelectChange}
                    title={t("brand.views.tags")}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </DialogCreate>
    </div>
  );
};

export default TaskTabs;
